import { setToken } from '../utils/auth'

export const setTokenData = ({ commit }, payload) => {
  setToken('tokenYE', payload)
  commit('setToken', payload)
}
